var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMagnifier = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.8 19C31.8 26.0692 26.0692 31.8 19 31.8C11.9308 31.8 6.2 26.0692 6.2 19C6.2 11.9308 11.9308 6.2 19 6.2C26.0692 6.2 31.8 11.9308 31.8 19ZM29.0365 30.1478C26.3784 32.5425 22.8594 34 19 34C10.7157 34 4 27.2843 4 19C4 10.7157 10.7157 4 19 4C27.2843 4 34 10.7157 34 19C34 22.6329 32.7085 25.9641 30.5596 28.5597L44 42L42.4443 43.5557L29.0365 30.1478Z",
  fill: "#4585ff"
})));
export default SvgIconMagnifier;